import { WebsiteCarbonBadge } from 'react-websitecarbon-badge';
import { QRCodeCanvas } from 'qrcode.react';
import { useState } from 'react';
import './DisclaimerPopup.css';
import { FaTimes } from 'react-icons/fa';

export const DisclaimerPopup = ({ isOpenDisclaimer, onCloseDisclaimer, news }) => {
    const [showQR, setShowQR] = useState(false);
    const prefersDarkMode = window.matchMedia("(prefers-color-scheme: dark)");
    const qrCodeText = window.location.href;

    if (!isOpenDisclaimer) return null;

    const sourceCounts = news.reduce((acc, item) => {
        acc[item.source] = (acc[item.source] || 0) + 1;
        return acc;
    }, {});

    return (
        <div className="popup-overlay">
            <div className="popup-content">
                <div className="popup-header">
                    <h2>Selidik v1.6</h2>
                    <button className="close-button" onClick={onCloseDisclaimer}>
                        <FaTimes />
                    </button>
                </div>
                <div className="popup-body">
                    <p>oleh Affandy Murad</p>
                    <div className="section-header">
                        <h2>Kode QR</h2>
                        <button
                            className="toggle-button"
                            onClick={() => setShowQR(!showQR)}
                        >
                            {showQR ? 'Sembunyikan' : 'Tampilkan'}
                        </button>
                    </div>
                    {/* QR Code Section */}
                    {showQR && (
                        <div className="qr-code-section">
                            <QRCodeCanvas value={qrCodeText} size={200} />
                            <p className="qr-code-text">{qrCodeText}</p>
                        </div>
                    )}

                    <h2>Rincian Berita</h2>
                    <ul className="source-list">
                        {Object.entries(sourceCounts).map(([source, count]) => (
                            <li key={source}>{source} : {count}</li>
                        ))}
                    </ul>
                    {/* Website Carbon Badge */}
                    <h2>Jejak Karbon</h2>
                    <div>
                        <WebsiteCarbonBadge url={window.location.href} dark={prefersDarkMode.matches} />
                    </div>
                    <h2>Penafian</h2>
                    <p className="disclaimer-text">
                        Situs web ini mengumpulkan dan menyajikan berita dari berbagai sumber yang tertera.
                        {' '}
                        <strong>
                            <a href="https://affandymurad.netlify.app/" target="_blank" rel="noopener noreferrer">
                                Affandy Murad
                            </a>
                        </strong>
                        {' '}
                        selaku pengelola situs tidak bertanggung jawab atas keakuratan, kelengkapan, atau keandalan konten berita yang disajikan.
                        Seluruh konten generatif dihasilkan menggunakan teknologi{' '}
                        <strong>Gemini AI ✨</strong> milik <strong>Google</strong> dan berada di luar kendali saya sebagai pembuat situs.
                        Semua konten ditulis dalam <strong>Bahasa Indonesia</strong>, tunduk pada peraturan hukum yang berlaku di Indonesia dan internasional,
                        serta bertujuan memerangi{' '}
                        <strong>
                            <a
                                href="https://www.unesco.org/en/articles/unesco-empowers-indonesian-wikipedia-administrators-combat-disinformation-and-hate-speech-ahead-2024"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                misinformasi, disinformasi, dan malinformasi [EN]
                            </a>
                        </strong>
                        {' '}
                        dengan menyediakan informasi yang transparan. Namun, kami menyarankan Anda untuk selalu memverifikasi informasi dari sumber resmi atau ahli terkait.
                        Dengan mengakses situs ini, Anda menyetujui bahwa segala informasi yang disajikan bersifat informatif dan tidak dapat dijadikan sebagai dasar mutlak untuk pengambilan keputusan.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default DisclaimerPopup;